// if not valid => just send ""
export const normalizePhone = (value: string | null): string | null => {
  if (!value) return "";

  // Remove all whitespace
  const noSpaces = value.replace(/\s+/g, "");

  // Ensure it starts with '+'
  const normalized = noSpaces.startsWith("+") ? noSpaces : "+" + noSpaces;

  // If it's just a dial code (1–4 digits after the +), treat it as empty
  const isOnlyDialCode = /^\+\d{1,4}$/.test(normalized);

  return isOnlyDialCode ? "" : normalized;
};
